import { PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { put, select, takeEvery, call } from "redux-saga/effects";
import { RootState } from "../reducers/rootReducer";
import {
    checkAuthStatusAction,
    loadUserState,
    loginAction,
    USER_ACTIONS,
} from "../reducers/userReducer";
import { getAuthToken } from "../../utils/local-storage";
import logger from "../../utils/logger";
import {
    AUTH_TOKEN_RESPONSE_HEADER,
    getSdk,
    setAuthToken,
    validateGoogleCallback,
} from "../../utils/network";
import { LoginInput, UserProfile } from "generated-interfaces/graphql";
import { AxiosResponse } from "axios";

function* loadSavedUserState() {
    logger.debug("Attempting to load previous user state");
    const authToken = getAuthToken();
    if (authToken) {
        setAuthToken(authToken);
        const sdk = getSdk();
        try {
            const response = yield sdk.authStatus();
            yield put(USER_ACTIONS.loginSuccess(response.authStatus));
        } catch (error) {
            logger.error("Invalid saved auth token", error);
        }
    }
    yield put(USER_ACTIONS.loadUserStateSuccess());
}

function* login(action: PayloadAction<LoginInput>) {
    logger.debug("Attempting to log the user in");
    const { code, scope } = action.payload;
    try {
        yield put(USER_ACTIONS.loginInit());
        const loginResponse: AxiosResponse<UserProfile> = yield call(
            validateGoogleCallback,
            code,
            scope
        );
        setAuthToken(loginResponse.headers[AUTH_TOKEN_RESPONSE_HEADER]);
        yield put(USER_ACTIONS.loginSuccess(loginResponse.data));
        // yield put(ERROR_ACTIONS.clearErrors());
        logger.debug("Successfully logged in user", login);
        yield put(push("/log"));
    } catch (errorResponse) {
        logger.error("Login Failed", errorResponse);
        yield put(USER_ACTIONS.loginFailed());
        // yield put(
        //     ERROR_ACTIONS.loginFailure(
        //         errorResponse.response?.errors || errorResponse
        //     )
        // );
    }
}

function* checkAuthStatus() {
    logger.debug("Attempting to check auth status");
    const sdk = getSdk();
    try {
        const isLoggedIn = yield select(
            (state: RootState) => state.user.isLoggedIn
        );
        if (!isLoggedIn) {
            logger.info("Not Logged In For checkAuthStatus");
            return;
        }
        const response = yield sdk.authStatus();
        yield put(USER_ACTIONS.authCheckSuccess(response.authStatus));
    } catch (error) {
        logger.error("Auth Status Check Failed", error);
        // Don't redirect if it's a network error. GraphQL will always return 200
        if (error && error.response && error.response.status === 200) {
            yield put(USER_ACTIONS.logout());
            yield put(push("/login"));
        }
    }
}

export default function* userSaga() {
    yield takeEvery(loginAction.toString(), login);
    yield takeEvery(checkAuthStatusAction.toString(), checkAuthStatus);
    yield takeEvery(loadUserState.toString(), loadSavedUserState);
}
